import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Button from '@mui/material/Button';
import classNames from 'classnames';
import Environment from '@/constants/Environment';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import useMobileView from '@/hooks/ui/useMobileView';
import useCurrentOrg from '@/lib/hooks/swr/useCurrentOrg';
import useCurrentUser from '@/lib/hooks/useCurrentUser';
import translate from '@/lib/intl/translate';
import userActionTypes from '@/rdx/actionTypes';

function SuperAdminHeader() {
  const dispatch = useDispatch();
  const history = useHistory();
  const isMobile = useMobileView();

  const { data } = useCurrentOrg();
  const { isImpersonating } = useCurrentUser();

  const orgName = data?.orgName;

  const handleDeimpersonate = () => {
    dispatch({
      type: userActionTypes.LOGIN_DEIMPERSONATE,
    });
    history.push(AuthRoutes.LANDING);
  };

  let environment = Environment.DEVELOPMENT;
  if (window.location.hostname === 'home.instil.io') {
    environment = Environment.PRODUCTION;
  }
  if (
    window.location.hostname === 'home.staging.instil.us' ||
    window.location.hostname.includes('netlify.app')
  ) {
    environment = Environment.STAGING;
  }

  return (
    <div className="sticky top-0 z-20 flex h-full w-full flex-col [grid-area:header]">
      <header
        className={classNames({
          'bg-chart-6': environment === Environment.PRODUCTION,
          'bg-chart-7': environment === Environment.STAGING,
          'bg-warning-main': environment === Environment.DEVELOPMENT,
        })}
      >
        <div className="flex h-12 items-center justify-between px-4 sm:h-16">
          <div>
            <div>{translate('SUPER_ADMIN')}</div>
            <div className="type-caption1">{translate(environment)}</div>
          </div>
          {!isMobile && orgName && (
            <div className="flex flex-col items-center justify-center">
              <div className="type-caption1">
                {translate('CURRENTLY_VIEWING_LABEL')}
              </div>
              <div className="font-semibold leading-6 type-h1">{orgName}</div>
            </div>
          )}
          {isImpersonating ? (
            <div className="flex flex-col items-end justify-center">
              <div className="type-caption1">impersonating:</div>
              <div className="font-semibold leading-6">
                {isImpersonating.join(', ')}{' '}
                <Button
                  type="text"
                  classes={{
                    root: 'p-0 font-normal text-xs underline normal-case',
                  }}
                  onClick={handleDeimpersonate}
                >
                  (cancel)
                </Button>
              </div>
            </div>
          ) : (
            <div className="w-40" />
          )}
        </div>
      </header>
    </div>
  );
}

export default SuperAdminHeader;
